import { render, staticRenderFns } from "./button.vue?vue&type=template&id=01d38428&scoped=true"
import script from "./button.ts?vue&type=script&lang=js&external"
export * from "./button.ts?vue&type=script&lang=js&external"
import style0 from "./button.vue?vue&type=style&index=0&id=01d38428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d38428",
  null
  
)

export default component.exports